import React, { useCallback } from 'react';
import { NSPackages } from '../../types/interfaces/NSPackages';
import TableWithState from '../../components/TableWithState/TableWithState';
import { ETables } from '../../types/enums/ETables';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import ImagePreview from '../../components/ImagePreview/ImagePreview';
import { Cell, Column } from 'react-table';
import HeaderCheckbox from './components/HeaderCheckbox/HeaderCheckbox';
import RowCheckbox from './components/RowCheckbox/RowCheckbox';

const tableName = ETables.Packages;

const Packages = () => {
  const cellStyleHandler = useCellStatusStyleHandler();

  const { t } = useTranslation();

  const dataFormatter = useCallback(
    (dataTable: NSPackages.ITableItem[]): NSPackages.IItemDataFormatted[] =>
      dataTable.map((table) => ({
        _id: table._id,
        group: table?.promocodeGroups || '',
        carrierBundle: table.carrierBundle,
        autoRenewing: t(tPaths.global.yesNo(!!(table.autoRenewing === 'Yes'))),
        price: table.price,
        status: table.status.current,
        title: table.title,
        label: table.label,
        image: (cell: Cell) => <ImagePreview src={table.imageIntro} />,
        jsxCheckbox: (cell: Cell<any>) => <RowCheckbox tableName={tableName} cell={cell} propNameForId={'_id'} />,
      })),
    [t],
  );

  const columns = useColumnsHeaders([
    {
      accessorAsHeader: 'jsxCheckbox',
      customHeader: (column: { data: { _id: string }[] } & Column) => (
        <HeaderCheckbox tableName={tableName} idList={column.data.map((plan) => plan._id)} />
      ),
    },
    { accessorAsHeader: 'image' },
    { accessorAsHeader: 'status' },
    { accessorAsHeader: 'group' },
    { accessorAsHeader: 'title' },
    { accessorAsHeader: 'label' },
    { accessorAsHeader: 'price' },
    { accessorAsHeader: 'autoRenewing' },
    { accessorAsHeader: 'carrierBundle' },
  ]);

  return (
    <TableWithState
      tableName={tableName}
      dataFormatter={dataFormatter}
      cellStyleHandler={cellStyleHandler}
      columns={columns}
      refreshable={true}
      exportable={true}
    />
  );
};

export default Packages;
